import React from "react"
import styles from "../files__moderation.jcss"
import translate from "core/translate"
import { cn } from "ethcss"
import { colors, grid, text } from "theme"
import EditText from "blocks.simple/editText/editText"
import Icon from "blocks.simple/icon/icon"

const MODERATION_STATUS = {
    "pending": {
        text: translate('moderationPending'),
        svg: "pendingContentModeration",
    },
    "approved": {
        text: translate('contentApproved'),
        svg: "approvedContentModeration"
    },
    "rejected": {
        text: translate('contentRejected'),
        svg: "rejectedContentModeration"
    }
}

const FilesModerationStatus = ({ selectedInfo, onClose }: { selectedInfo: any, onClose: () => void}) => {
    const status: "pending" | "rejected" | "approved" = selectedInfo.moderation ? selectedInfo.moderation.status : null
    const comment = status === "rejected" ? selectedInfo.moderation.comment : ""

    if (!status) return null;

    return (
        <div className={cn(styles.wrapper, grid.centerBlock)}>
            <div className={text.bold}>
                {translate('status')}
            </div>
            <div className={styles.statusWrapper}>
                <Icon
                    type={MODERATION_STATUS[status].svg}
                />
                <div style={{color: colors.blackLight}}>
                    {MODERATION_STATUS[status].text}
                </div>
                {status === "rejected" && (
                    <div style={{color: colors.grey}}>
                        {translate("fixContent")}
                    </div>
                )}
            </div>
            {comment && (
                <>
                    <div className={text.bold}>
                        {translate('comment')}
                    </div>
                    <EditText
                        disabled
                        value={comment}
                        type="area"
                    />
                </>
            )}
        </div>)
}

export default FilesModerationStatus